import React from 'react';
import PropTypes from 'prop-types';

import { CHILDREN_PROP_TYPES } from 'propTypes';
import SecondaryCta from 'components/Buttons/SecondaryCta';
import {
  getHeroTextColor,
  getItemDescriptionsAndPricesTypography
} from 'styles/helpers/getThemeStyles';

function HeroSecondaryCta({ handleClick, label, dataTestId, hasHeroImage }) {
  const ownHeroSecondaryCtaState = theme => {
    const fontStyles = getItemDescriptionsAndPricesTypography(theme);
    const color = getHeroTextColor(theme, hasHeroImage);

    return {
      color,
      textAlign: 'center',
      textTransform: 'none',
      ...fontStyles
    };
  };
  return (
    <SecondaryCta
      label={label}
      dataTestId={dataTestId}
      handleClick={handleClick}
      fullWidth
      ownState={{ heroSecondaryCta: ownHeroSecondaryCtaState }}
    />
  );
}

HeroSecondaryCta.propTypes = {
  handleClick: PropTypes.func,
  label: CHILDREN_PROP_TYPES,
  dataTestId: PropTypes.string,

  hasHeroImage: PropTypes.bool
};

export default HeroSecondaryCta;
